module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/event-1-e95596fc36a575d6e1584239c71d9f19.jpg";